import { NgModule } from "@angular/core";
import { HttpModule, JsonpModule } from "@angular/http";

// Modules
import { SpinnerComponentModule } from "./Spinner/SpinnerComponentModule";
import { DropdownComponentModule } from "./Dropdown/DropdownComponentModule";
import { EnvironmentComponentModule } from "./Environment/EnvironmentComponentModule";

// Components
import { RequestSSOLoginComponent } from "./Authorization/RequestSSOLoginComponent";
import { ConcludeSSOLoginComponent } from "./Authorization/ConcludeSSOLoginComponent";
import { UnauthorizedAccessComponent } from "./Authorization/UnauthorizedAccessComponent";
import { DropdownComponent } from "./Dropdown/DropdownComponent";
import { SpinnerComponent } from "./Spinner/SpinnerComponent";
import { EnvironmentComponent } from "./Environment/EnvironmentComponent";

// Services
import { UserService } from "./Authorization/UserService";
import { AuthorizationHelperService } from "./Authorization/AuthorizationHelperService";
import { GlobalService } from "./GlobalService";
import { LocalStorageService } from "./Storage/LocalStorageService";
import { SessionStorageService } from "./Storage/SessionStorageService";
import { MessagesService } from "./Messages/MessagesService";
import { BrandingService } from "./Branding/BrandingService";
import { AuthorizationService } from "./Authorization/AuthorizationService";
import { AppNavigationService } from "./Extranet/AppNavigationService";
import { HttpServiceBase } from "./HttpService/HttpServiceBase";
import { GlobalReferenceService } from "./Authorization/GlobalReferenceService";

// Other providers
import { RouteMonitor } from "./Route/RouteMonitor";
import { AppSettings } from "./AppSettings";
import { MomentPipe } from "./CustomPipes/MomentPipe";
// Re-export all individually
export * from "./Dropdown/DropdownComponentModule";
export * from "./Spinner/SpinnerComponentModule";
export * from "./Environment/EnvironmentComponentModule"
export * from "./ApplicationBar/ApplicationBarModule"

export * from "./Authorization/RequestSSOLoginComponent";
export * from "./Authorization/ConcludeSSOLoginComponent";
export * from "./Authorization/UnauthorizedAccessComponent";
export * from "./Dropdown/DropdownComponent";
export * from "./Spinner/SpinnerComponent";
export * from "./Environment/EnvironmentComponent"
export * from "./ApplicationBar/ApplicationBarComponent"

export * from "./Authorization/UserService";
export * from "./Authorization/AuthorizationHelperService";
export * from "./GlobalService";
export * from "./Messages/MessagesService";
export * from "./Extranet/AppNavigationService";
export * from "./Branding/BrandingService";
export * from "./Authorization/AuthorizationService";
export * from "./HttpService/HttpServiceBase";
export * from "./Storage/LocalStorageService";
export * from "./Storage/SessionStorageService";
export * from "./Authorization/GlobalReferenceService";
export * from "./ApplicationBar/FreshdeskWidgetService";

export * from "./Route/RouteMonitor";
export * from "./AppSettings";
export * from "./CustomPipes/MomentPipe";

// Re-export as a single module
@NgModule({
    imports: [
        SpinnerComponentModule,
        DropdownComponentModule,
        HttpModule,
        EnvironmentComponentModule
    ],
    exports: [
        MomentPipe,
        RequestSSOLoginComponent,
        ConcludeSSOLoginComponent,
        UnauthorizedAccessComponent
    ],
    declarations: [
        MomentPipe,
        RequestSSOLoginComponent,
        ConcludeSSOLoginComponent,
        UnauthorizedAccessComponent,
    ],
    providers: [
        UserService,
        AuthorizationHelperService,
        GlobalService,
        LocalStorageService,
        SessionStorageService,
        MessagesService,
        BrandingService,
        AuthorizationService,
        AppNavigationService,
        RouteMonitor,
        GlobalReferenceService
    ]
})

export class NpsCommonModule { }



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/index.ts